<template>
  <div class="doctor-entry-page employee-entry-page">
    <PageHeader icon="fas fa-user-tie">
      <template #title>Tambah Karyawan</template>
      <template #subtitle>
        Lengkapi identitas, akun, penempatan, dan informasi ketenagakerjaan karyawan.
      </template>
    </PageHeader>

    <div class="row">
      <div class="col-md-12">
        <HrForm :form="form" :route="'employees'" :password="true"/>
      </div>
    </div>

  </div>
</template>

<script>

import HrForm from '@/component/human-resource/Form.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  data(){
    return {
      form:{
        email: "",
        name: "",
        birt_place: "",
        birt_date: "",
        address: "",
        phone: "",
        mobile_phone: "",
        id_card_number: "",
        employee_number_id:"",
        password: "",
        password_confirmation: "",
        position_id:"",
        department_id:"",
        work_start_time: "09:00",
        work_end_time: "17:00",
        employment_status: "permanent", join_date: "", end_date: "", base_salary: 0,
        bank_name: "", bank_account_number: "", bank_account_name: "", npwp: "", ptkp_status: "TK/0",
        bpjs_health_number: "", bpjs_employment_number: "", str_number: "", str_expired_at: "", sip_number: "", sip_expired_at: "",
        photo: [],
        photo_name: "/images/default-profile.svg",
        isResetImg: false,
      }
    }
  },

  name: 'Add',

  components: {
    HrForm
  },
  

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Karyawan" },
      { title: "Daftar Karyawan", route: "/human-resource/employee/list" },
      { title: "Tambah Karyawan" },
    ])
  },

}
</script>
